import { Component, OnInit, Input } from '@angular/core';
import { MultiLangPipe } from "../../pipes/multi-lang.pipe";
import { AssetTypePipe } from "../../pipes/asset-type.pipe";
import { AppService } from "../../services/app.service";
import { GatemanService } from 'src/app/services/gateman.service';
interface ButtonProperties {
  url: string,
  text?: string,
  expand?: string,
  fill?: string,
  size?: string,
  target?: string,
  color?: string,
  download?: boolean,
  pageIndex?: string | number,
  source?: string | number
}
@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input() public diLayout;
  @Input() public config: {
    source?: number | string,
    asset?: Array<{ type: string, url: string, languageCode: Array<string> }> | { type: string, url: string, languageCode: Array<string> },
    url?: Array<{ languageCode: string, value: string }> | string
    expand?: string | undefined,
    fill?: string
    size?: string
    target?: string
    color?: string,
    text: Array<{ languageCode: string, value: string }> | string
    mapping?: {
      assetKey: string
    },
    pageIndex?: string | number,
  };

  private _button: ButtonProperties = {
    url: '',
    text: '',
    expand: undefined,
    size: 'default',
    target: '_blank',
    fill: 'solid',
    color: 'primary',
    download: false,
    source: 1,
    pageIndex: ''
  };

  public get button(): ButtonProperties {
    return this._button;
  }
  public set button(value: ButtonProperties) {
    this._button = value;
  }
  @Input() public data: any;


  constructor(private multiLangPipe: MultiLangPipe,
    private assetTypePipe: AssetTypePipe,
    private appService: AppService,
    private gatemanService: GatemanService) { }

  /**
   * onInit
   * @author Radhika Agnihotri
   * @task QLIKTAG-3786
   */
  ngOnInit() {

    if (this.config) {
      if (this.config.hasOwnProperty("source") && this.config.source) {
        //source = 1 asset type
        this.button.source = this.config.source;
        if (this.config.source == 1) {
          if (this.config.hasOwnProperty("mapping") && this.config.mapping) {
            if (this.config.mapping.hasOwnProperty("assetKey") && this.config.mapping.assetKey) {
              let assetPath = this.config.mapping.assetKey;
              let path = assetPath.split(".");
              //find asset obj/array from instance data
              let asset = this.appService.findObjectByPath(this.data["entityInformation"], path);
              if (asset) {
                let url = this.assetTypePipe.transform(asset);
                if (url && url != '') {
                  this.button.url = url;
                }
              }
            }
          }

        }

        //source = 2 external url
        if (this.config.source == 2) {
          if (this.config.hasOwnProperty('url') && this.config.url) {
            let url = this.multiLangPipe.transform(this.config.url).toString();
            const attributeRegex = /{{(.*?)}}/g;
            const attributeList = [];
            let match;
            while ((match = attributeRegex.exec(url)) !== null) {
              attributeList.push(match[1]);
            }
            for (let i in attributeList) {
              let path = attributeList[i].split(".");
              let asset = this.appService.findObjectByPath(this.data["entityInformation"], path);
              let urlKey;
              if (typeof (asset) == 'object' && asset?.length) {

                urlKey = this.assetTypePipe.transform(asset[0].value);

              } else {
                urlKey = this.assetTypePipe.transform(asset);
              }
              url = url.replace(new RegExp(`{{${attributeList[i]}}}`, 'g'), urlKey);
            }
            this.button.url = url
          }
        }


        //source = 3 internal page
        if (this.config.source == 3) {
          if (this.config.hasOwnProperty('pageIndex') && this.config.pageIndex) {
            this.button.pageIndex = this.config.pageIndex;

            try {
              const page = this.diLayout.pages[this.config.pageIndex];
              const { alias: url } = page;

              if (url && url != '') {
                this.button.url = url;
              }

            } catch (e) {
              console.log(e);
            }



          }
        }

      }

      //set button properties
      if (this.config.hasOwnProperty("text") && this.config.text) {
        this.button.text = this.multiLangPipe.transform(this.config.text).toString();
      }

      if (this.config.hasOwnProperty("expand") && this.config.expand) {
        this.button.expand = this.config.expand;
      }

      if (this.config.hasOwnProperty("fill") && this.config.fill) {
        this.button.fill = this.config.fill;
      }

      if (this.config.hasOwnProperty("size") && this.config.size) {
        this.button.size = this.config.size;
      }

      if (this.config.hasOwnProperty("target") && this.config.target) {
        if (this.config.target != 'download') {
          this.button.target = this.config.target;
        } else {
          //if target = download, redirect in a new tab 
          this.button.download = true;
          this.button.target = '_blank';
        }
      }

      if (this.config.hasOwnProperty("color") && this.config.color) {
        this.button.color = this.config.color;
      }
    }

  }

  /**
   * Navigate to page-alias
   * @author Neil C 
   * @task QLIKTAG-4058
   * @param alias 
   */
  go(alias) {
    this.gatemanService.routeMe(`p/${alias}`, { queryParams: { resetQueryParams: 1 } });
  }

}
